import { render } from "./TextTrimmer.vue?vue&type=template&id=1e4b065f&scoped=true"
import script from "./TextTrimmer.vue?vue&type=script&lang=js"
export * from "./TextTrimmer.vue?vue&type=script&lang=js"

import "./TextTrimmer.vue?vue&type=style&index=0&id=1e4b065f&scoped=true&lang=css"

import exportComponent from "/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1e4b065f"]])

export default __exports__